var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.icon, _vm.mini && _vm.$style.iconMini, _vm.$color[_vm.classColor]]},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.selectIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }